<div class="form-content-item">
  <form [formGroup]="form" (keydown.enter)="$event.stopPropagation()">
    <div class="form-header-item">
      <div>
        <h2 *ngIf="currentItem?.displayName">{{ currentItem.displayName }} [{{ currentItem.code }}]</h2>
      </div>
      <div class="div-btns-top">
        <action-bar
          [showAddToFavorites]="!favoriteId && currentItem?.resourceId"
          [showRemoveFromFavorites]="!!favoriteId"
          [showSave]="manageProducts && (currentItem?.canUpdate === true || !currentItem?.resourceId)"
          [showDuplicate]="!!currentItem?.canDuplicate"
          [showDelete]="currentItem?.resourceId && ((manageProducts && currentItem?.canUpdate === true) || currentItem?.canUnlink)"
          [showCalculCEU]="currentItem?.resourceId && manageProducts && currentItem?.canUpdate === true"
          [showShare]="currentItem?.resourceId && manageProducts && currentItem?.canUpdate === true"
          (onAddToFavorites)="addToFavorite(currentItem.resourceId!)"
          (onRemoveFromFavorites)="removeFromFavorite()"
          (onSave)="clickSave(currentItem)"
          (onDuplicate)="onDuplicate(currentItem.resourceId!)"
          (onDelete)="onDeleteDialog(currentItem.resourceId!)"
          (onCalculCEU)="calculCEU()"
          (onShare)="onShare(currentItem.resourceId!)"></action-bar>
      </div>
    </div>
    <div>
      <div *ngIf="showErrorMessage" class="alert-danger">{{ 'formula_error_not_available' | translate }}</div>
      <div class="readonly-banner" *ngIf="!manageProducts || !(currentItem?.canUpdate || !currentItem?.resourceId)">
        <mat-icon>lock</mat-icon>
        <span>{{ 'common_read_only_notice' | translate }}</span>
      </div>
      <div class="identification" [class]="{ 'disabled-form': !manageProducts || !(currentItem?.canUpdate || !currentItem?.resourceId) }">
        <h3 class="title-margin-top">{{ 'common_section_identification' | translate }}</h3>
        <mat-card>
          <mat-grid-list cols="10" rowHeight="60px" gutterSize="20px">
            <mat-grid-tile colspan="2">
              <mat-form-field>
                <mat-label color="accent">{{ 'common_field_code' | translate }}</mat-label>
                <input matInput formControlName="code" minlength="2" maxlength="15" required />
                <mat-error *ngIf="formCrls.code.invalid">{{ 'ref_error_code_required' | translate }}</mat-error>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <mat-form-field>
                <mat-label>{{ 'common_field_label' | translate }}</mat-label>
                <input matInput formControlName="displayName" maxlength="100" required />
                <mat-hint align="end">{{ form.value.displayName?.length || 0 }} / 100</mat-hint>
                <mat-error *ngIf="formCrls.displayName.invalid">{{ 'ref_error_label_required' | translate }}</mat-error>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="3" *ngIf="currentItem.resourceId">
              <mat-form-field>
                <mat-label>{{ 'common_field_owner' | translate }}</mat-label>
                <input matInput disabled [value]="formCrls.owner.value | resourceAuthor: currentItem" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="2" *ngIf="currentItem.resourceId">
              <mat-form-field>
                <mat-label>{{ 'common_field_creator' | translate }}</mat-label>
                <input matInput disabled [value]="formCrls.creator.value | resourceAuthor: currentItem" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="2" *ngIf="currentItem.resourceId && currentItem.createDate">
              <mat-form-field>
                <mat-label>{{ 'project_field_creation_date' | translate }}</mat-label>
                <input disabled matInput value="{{ currentItem?.createDate | localizedDate: 'shortDate' }}" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="2" *ngIf="currentItem.resourceId && currentItem.updateDate && currentItem.updateDate !== currentItem.createDate">
              <mat-form-field>
                <mat-label>{{ 'project_field_last_modification_date' | translate }}</mat-label>
                <input disabled matInput value="{{ currentItem?.updateDate | localizedDate: 'shortDate' }}" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="2" *ngIf="currentItem.resourceId && currentItem.modifier && currentItem.modifier !== ' ' && currentItem.updateDate !== currentItem.createDate">
              <mat-form-field>
                <mat-label>{{ 'project_field_modified_by' | translate }}</mat-label>
                <input disabled matInput [value]="currentItem?.modifier | resourceAuthor: currentItem" />
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list>
        </mat-card>
      </div>
      <div class="formule" [class]="{ 'disabled-form': !manageProducts || !(currentItem?.canUpdate || !currentItem?.resourceId) }">
        <div class="title title-margin-top">
          <h3>{{ 'formula_section' | translate }}</h3>
          <mat-card>
            <div class="row">
              <div class="col-3">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_family' | translate }}</mat-label>
                  <mat-select formControlName="familyId" (selectionChange)="familyChange($event.value)" required>
                    <mat-option *ngFor="let f of families" [value]="f.familyId"> {{ f.displayName }} [{{ f.code }}] </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-2">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_work_unit' | translate }}</mat-label>
                  <mat-select formControlName="workUnityId" (selectionChange)="changeWorkUnity($event.value, unitys)" required>
                    <mat-option *ngFor="let u of unitys" [value]="u.workUnityId">
                      {{ u.displayName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-2" *ngIf="hasDensity">
                <mat-form-field>
                  <mat-label>{{ 'formula_field_density' | translate }}</mat-label>
                  <input matInput formControlName="density" type="number" required />
                  <mat-error *ngIf="formCrls.density.errors?.required && (form.controls.density.touched || this.formSubmitted)">
                    {{ formCrls.density.errors?.required }}
                  </mat-error>
                  <mat-error *ngIf="formCrls.density.errors?.positive">{{ 'formula_error_density_positive' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col-2" *ngIf="isHygrometryRateVisible">
                <mat-form-field>
                  <mat-label>{{ 'product_field_hygrometry_rate' | translate }}</mat-label>
                  <input matInput formControlName="hygrometryRate" type="number" />
                  <mat-error *ngIf="formCrls.hygrometryRate.errors?.max">{{ 'product_error_hygrometry_max' | translate }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'common_field_description' | translate }}</mat-label>
                  <textarea type="text" formControlName="description" rows="3" matInput class="resetPointerEvents" [readonly]="!manageProducts || !(currentItem.canUpdate || !currentItem.resourceId)"></textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-3" *ngIf="!(!manageProducts || !(currentItem?.canUpdate || !currentItem?.resourceId))">
                <div class="justificatif" [matTooltip]="!currentItem?.resourceId ? ('ref_save_before_add_proof' | translate) : ''">
                  <input id="singleFile" type="file" #proofUpload class="inputfile" accept="application/pdf" (change)="uploadProof(currentItem.resourceId, proofUpload.files)" #fileInput [disabled]="!currentItem?.resourceId" />
                  <button mat-mini-fab color="accent" class="mini-fab" (click)="fileInput.click()" [disabled]="!currentItem?.resourceId">
                    <mat-icon>add</mat-icon>
                  </button>
                  <label [class.cursor]="currentItem?.resourceId" [attr.for]="currentItem?.resourceId ? 'singleFile' : null">{{ 'ref_add_proof_pdf' | translate }}</label>
                </div>
              </div>
              <div class="col-4">
                <div class="justificatif resetPointerEvents" *ngIf="form.value.fileName">
                  <button mat-mini-fab color="warn" class="mini-fab" (click)="deleteFile()">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                  <a [href]="currentItem.resourceId ? justificationFilePath + form.value.fileDescription : form.value.fileDescription" target="_blank">{{ form.value.fileName }} </a>
                </div>
              </div>
              <!-- The FDES has its own slot: it does not replace the justification file, which stays the FTP. -->
              <div class="col-4" *ngIf="canViewFdes && (latestFdes?.pdfRelativePath || latestFdes?.wordRelativePath)">
                <div class="justificatif resetPointerEvents">
                  <button mat-mini-fab color="accent" class="mini-fab" (click)="downloadFdes()">
                    <mat-icon>download</mat-icon>
                  </button>
                  <a class="cursor" (click)="downloadFdes()">{{ fdesFileName }}</a>
                </div>
              </div>
            </div>
            <div class="industrie">
              <div class="row">
                <div class="col-3">
                  <mat-form-field>
                    <mat-label>{{ 'formula_field_industry' | translate }}</mat-label>
                    <mat-select formControlName="industryId" (selectionChange)="industrieChange($event.value)" required>
                      <mat-option>{{ 'formula_option_select' | translate }}</mat-option>
                      <mat-option *ngFor="let ind of listIndustries" [value]="ind.resourceId"> {{ ind?.displayName }} [{{ ind.code }}] </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <!--Combustible-->
              <div *ngIf="currentItem && currentItem.combustibles && currentItem.combustibles.length > 0">
                <h3>{{ 'formula_section_combustible' | translate }}</h3>
                <div class="row formula-fab-row">
                  <div class="col-6">
                    <table mat-table [dataSource]="currentItem.combustibles || []" class="table-combustible col-12" aria-describedby="table-combustibles">
                      <!-- Combustible Column -->
                      <ng-container matColumnDef="combustibleDisplayName">
                        <th mat-header-cell *matHeaderCellDef>{{ 'formula_col_combustible' | translate }}</th>
                        <td mat-cell *matCellDef="let element">
                          {{ element.combustibleDisplayName }}
                        </td>
                      </ng-container>

                      <!-- Code Column -->
                      <ng-container matColumnDef="combustibleCode">
                        <th mat-header-cell *matHeaderCellDef>{{ 'common_field_code' | translate }}</th>
                        <td mat-cell *matCellDef="let element">{{ element?.combustibleCode }}</td>
                      </ng-container>

                      <!-- Pourcentage Column -->
                      <ng-container matColumnDef="value">
                        <th mat-header-cell *matHeaderCellDef>{{ 'formula_col_percentage' | translate }}</th>
                        <td mat-cell *matCellDef="let element">{{ round2(element?.value) }}%</td>
                      </ng-container>

                      <ng-container matColumnDef="edit">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                          <mat-icon (click)="editValueCombustible(element)">edit</mat-icon>
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                    </table>
                    <div class="row formula-temp-row">
                      <div class="col-6">
                        <mat-form-field>
                          <mat-label>{{ 'formula_field_making_temperature' | translate }} *</mat-label>
                          <input matInput formControlName="makingTemperature" type="number" />
                          <mat-error *ngIf="formCrls.makingTemperature.errors?.required">{{ 'formula_error_making_temperature_required' | translate }}</mat-error>
                          <mat-error *ngIf="formCrls.makingTemperature.errors?.min">{{ 'formula_error_making_temperature_min' | translate }}</mat-error>
                          <mat-error *ngIf="formCrls.makingTemperature.errors?.max">{{ 'formula_error_making_temperature_max' | translate }}</mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="ratioCombustible">{{ 'formula_total_ratio' | translate }} : {{ round2(form.controls.ratioCombustibles.value) }}%</div>
                    <input formControlName="ratioCombustibles" [hidden]="true" type="number" />
                    <div *ngIf="formCrls.ratioCombustibles.invalid" class="mat-error ratioCombustibleError">{{ 'formula_error_ratio_100' | translate }}</div>
                  </div>
                  <div class="col-6 fdes-scope formula-thermal" *ngIf="canViewFdes && energyProfile">
                    <app-fdes-thermal-card
                      [conso]="thermalConso"
                      [consoUnit]="energyProfile?.consoUnit || 'MJ/t'"
                      [elec]="energyProfile?.ratios?.elec || 0"
                      [gnr]="energyProfile?.ratios?.gnr || 0"
                      [comb]="energyProfile?.ratios?.combustibles || 0"
                      [combustibles]="thermalCombustibles"
                      [feUnit]="energyProfile?.feUnit || 'kgCO2e/MJ'"></app-fdes-thermal-card>
                  </div>
                </div>
              </div>
            </div>
          </mat-card>
        </div>

        <div class="composition">
          <div class="title title-margin-top">
            <h3>{{ 'product_section_composition' | translate }}</h3>
            <button mat-mini-fab (click)="addProduit(currentItem)" type="button">
              <mat-icon>add</mat-icon>
            </button>
          </div>
          <div>
            <mat-accordion hideToggle>
              <mat-expansion-panel expanded>
                <mat-expansion-panel-header #panel (click)="panel._toggle()">
                  <mat-panel-title>
                    <div class="row text-bold">
                      <div class="col-1 text-center">
                        <mat-icon (click)="panel._toggle()"> {{ panel._isExpanded() ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
                      </div>
                      <div class="col-1">{{ 'common_field_code' | translate }}</div>
                      <div class="col-2">{{ 'common_field_label' | translate }}</div>
                      <div class="col-2">{{ 'common_field_transport' | translate }}</div>
                      <div class="col-1">{{ 'common_field_energy' | translate }}</div>
                      <div class="col-1">{{ 'common_field_distance' | translate }}</div>
                      <div class="col-1 text-center">{{ 'common_double_freight' | translate }}</div>
                      <div class="col-1 text-center">{{ 'dialog_formula_composition_col_multimodal' | translate }}</div>
                      <div class="col-1">{{ 'formula_col_ratio' | translate }}</div>
                      <div class="col-1"></div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ng-container *ngIf="currentItem?.produits && currentItem?.produits?.length; else no_products">
                  <div class="row" [ngClass]="{ backgroundColor: indexPro % 2 == 0 }" *ngFor="let item of currentItem?.produits; let indexPro = index">
                    <div class="col-1 badge-cell">
                      <badge-statut [item]="item"></badge-statut>
                    </div>
                    <div class="col-1">
                      {{ item.code }}
                    </div>
                    <div class="col-2 align-center">
                      {{ item.displayName }}
                      <mat-icon class="edit-product-name-icon" (click)="editProduct(item)"> change_circle </mat-icon>
                      <mat-icon class="transport-deleted" [matTooltip]="'project_error_product_unavailable' | translate: { name: item.displayName }" *ngIf="item.resourceNotAvailableForThisVersion"> error </mat-icon>
                    </div>
                    <div class="col-2">
                      <span
                        >{{ item.transportName ? item.transportName : ('common_no_transport' | translate) }}
                        <mat-icon class="transport-deleted" [matTooltip]="'project_error_transport_deleted' | translate: { name: item.transportName }" *ngIf="item.transportDeleted">error </mat-icon>
                      </span>
                    </div>
                    <div class="col-1">
                      <div *ngIf="!item.isMultimodal">
                        {{ item.energyName ? item.energyName : ('common_no_energy' | translate) }}
                      </div>
                    </div>
                    <div class="col-1">
                      <div *ngIf="!item.isMultimodal">
                        {{ item.distance }}
                      </div>
                    </div>
                    <div class="col-1 text-center">
                      <div *ngIf="!item.isMultimodal">
                        <mat-checkbox [checked]="item?.doubleCargo ? true : false" (change)="item.doubleCargo = !item?.doubleCargo; unSaved = true"> </mat-checkbox>
                      </div>
                    </div>
                    <div class="col-1 text-center icon-color">
                      <mat-icon (click)="addMultimodal(item)">zoom_in</mat-icon>
                      <mat-icon (click)="deleteMultimodal(item)" *ngIf="item.isMultimodal; else elseBlockMultimodal">delete_outline </mat-icon>
                      <ng-template #elseBlockMultimodal>
                        <mat-icon></mat-icon>
                      </ng-template>
                    </div>
                    <div class="col-1">{{ item.ratio }}%</div>
                    <div class="col-1 icon-color text-center">
                      <mat-icon [matTooltip]="'common_tooltip_edit' | translate" (click)="editProduit(item)" *ngIf="!item.isMultimodal; else elseBlock">edit</mat-icon>
                      <ng-template #elseBlock>
                        <mat-icon [matTooltip]="'common_tooltip_edit' | translate" (click)="editRatio(item)">edit</mat-icon>
                      </ng-template>
                      <mat-icon [matTooltip]="'common_tooltip_delete' | translate" (click)="deleteProduit(indexPro)"> delete_outline</mat-icon>
                    </div>
                  </div>
                  <div *ngIf="currentItem.produits && currentItem.produits.length > 0" class="ratio">{{ 'formula_total_ratio' | translate }} : {{ form.controls.ratioProducts.value }}%</div>
                  <input formControlName="ratioProducts" [hidden]="true" type="number" />
                  <div *ngIf="formCrls.ratioProducts.invalid" class="mat-error ratioError">{{ 'formula_error_ratio_100' | translate }}</div>
                </ng-container>
                <ng-template #no_products>
                  <div *ngIf="this.formSubmitted || this.compositionTouched" class="mat-error compositionError">{{ 'formula_error_composition_required' | translate }}</div>
                </ng-template>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      </div>

      <div class="fdes-scope" *ngIf="canViewFdes && currentItem?.resourceId">
        <div class="fdes-formula">
          <div class="seve-card fdes-formula__gen">
            <div class="seve-card__head">
              <span class="seve-eyebrow-ic seve-eyebrow-ic--green"><mat-icon>eco</mat-icon></span>
              <span class="seve-eyebrow seve-eyebrow--green">{{ 'formula_fdes_rdf_eyebrow' | translate }}</span>
              <span class="seve-spacer"></span>
              <button type="button" class="seve-btn seve-btn--primary" *ngIf="showFdesButton" (click)="openGenerateFdes()"><mat-icon>eco</mat-icon>{{ (canGenerateFdes ? 'formula_fdes_generate_btn' : 'formula_fdes_history_btn') | translate }}</button>
            </div>
            <div class="seve-card__body">
              <p class="fdes-formula__desc" *ngIf="canGenerateFdes || fdesHistoryLoaded">{{ fdesDescriptionKey | translate }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="version col-6" *ngIf="currentItem.resourceId">
        <h3 class="title-margin-top" style="opacity: 0.8">{{ 'ref_section_db_version' | translate }}</h3>
        <mat-card>
          <div class="row">
            <div class="col-12">
              <mat-form-field>
                <mat-label>{{ 'ref_field_choose_version' | translate }}</mat-label>
                <mat-select [multiple]="false" formControlName="versionId" (selectionChange)="onVersionChange($event.value)">
                  <mat-option *ngFor="let p of dbVersions" [value]="p.versionId">
                    {{ p.versionName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>

      <div class="cout" *ngIf="currentItem?.ceu">
        <div class="title title-margin-top">
          <h3>{{ 'ref_section_env_cost_ton' | translate }}</h3>
          <mat-card formGroupName="ceu">
            <div class="row disabled-form">
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_energy_mj' | translate }}</mat-label>
                  <input matInput [value]="currentItem.ceu?.en" type="number" formControlName="en" [disabled]="!manageProducts || !(currentItem.canUpdate || !currentItem.resourceId)" />
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_co2_t' | translate }}</mat-label>
                  <input matInput [value]="currentItem.ceu?.coString" type="string" formControlName="coString" [disabled]="!manageProducts || !(currentItem.canUpdate || !currentItem.resourceId)" />
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_natural_aggregates' | translate }}</mat-label>
                  <input matInput [value]="currentItem.ceu?.gn" type="number" formControlName="gn" [disabled]="!manageProducts || !(currentItem.canUpdate || !currentItem.resourceId)" />
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_coated_aggregates' | translate }}</mat-label>
                  <input matInput [value]="currentItem.ceu?.ae" type="number" formControlName="ae" [disabled]="!manageProducts || !(currentItem.canUpdate || !currentItem.resourceId)" />
                </mat-form-field>
              </div>
            </div>
            <div class="row disabled-form">
              <div class="col-3">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_recycled_materials' | translate }}</mat-label>
                  <input matInput [value]="currentItem.ceu?.mr" type="number" formControlName="mr" [disabled]="!manageProducts || !(currentItem.canUpdate || !currentItem.resourceId)" />
                </mat-form-field>
              </div>
              <div class="col-4">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_reused_spoils' | translate }}</mat-label>
                  <input matInput [value]="currentItem.ceu?.drc" type="number" formControlName="drc" [disabled]="!manageProducts || !(currentItem.canUpdate || !currentItem.resourceId)" />
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div class="ressource" #resourceSection>
        <div class="title title-margin-top">
          <h3>{{ 'ref_section_resource_type' | translate }}</h3>
          <mat-card>
            <div class="row">
              <div class="col-4">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_project_type' | translate }}</mat-label>
                  <mat-select [multiple]="true" formControlName="projectType" [compareWith]="compareProjectTypes" required>
                    <mat-option *ngFor="let p of projectTypes" [value]="p" [disabled]="!manageProducts || !(currentItem?.canUpdate || !currentItem?.resourceId)">
                      {{ p.displayName | localizedLabel: 'projectType' : p.code }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-4">
                <span *ngIf="formCrls.projectType.invalid && (form.controls.projectType.touched || this.formSubmitted)" class="mat-error">{{ form.controls.projectType.errors?.validateProjectType | translate }}</span>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </form>
</div>
